(function() {
  'use strict';
  
  // Function to toggle collection info description
  function toggleCollectionInfo(button) {
    if (!button) return;
    
    const collectionInfo = button.closest('collection-page-info') || button.closest('.collection-page-info');
    if (!collectionInfo) return;
    
    const container = collectionInfo.querySelector('.collection-page-info__container');
    const description = collectionInfo.querySelector('.collection-page-info__description');
    if (!description) {
      return;
    }
    
    const isActive = description.classList.contains('active');
    
    if (isActive) {
      description.classList.remove('active');
      button.classList.remove('active');
      button.setAttribute('aria-expanded', 'false');
      if (container) {
        container.classList.remove('active');
      }
    } else {
      description.classList.add('active');
      button.classList.add('active');
      button.setAttribute('aria-expanded', 'true');
      if (container) {
        container.classList.add('active');
      }
    }
  }

  // Global event delegation - works immediately
  // Handles clicks on the button and any child elements (text, icon, etc.)
  document.addEventListener('click', function(e) {
    const button = e.target.closest('.collection-page-info__title');
    if (button) {
      e.preventDefault();
      e.stopPropagation();
      toggleCollectionInfo(button);
    }
  });

  // Function to attach listener to a single button
  function attachButtonListener(button) {
    if (button.hasAttribute('data-listener-attached')) return;
    
    button.setAttribute('data-listener-attached', 'true');
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      toggleCollectionInfo(button);
    });
  }

  // Function to parse rich text JSON and extract text content
  function parseRichTextJson(jsonString) {
    try {
      const data = JSON.parse(jsonString);
      if (data && data.children && Array.isArray(data.children)) {
        let text = '';
        function extractText(node) {
          if (node.type === 'text' && node.value) {
            text += node.value;
          }
          if (node.children && Array.isArray(node.children)) {
            node.children.forEach(extractText);
          }
        }
        data.children.forEach(extractText);
        return text.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');
      }
    } catch (e) {
      // Not valid JSON, return as is
    }
    return null;
  }

  // Function to fix rich text descriptions that are showing as JSON
  function fixRichTextDescriptions() {
    const descriptions = document.querySelectorAll('.collection-page-info__description');
    descriptions.forEach(function(description) {
      const contentDiv = description.querySelector('.collection-page-info__description-content');
      if (!contentDiv) return;
      
      const rawContent = contentDiv.textContent.trim();
      // Check if content looks like JSON (starts with {)
      if (rawContent.startsWith('{') && rawContent.includes('"type":"root"')) {
        const parsedHtml = parseRichTextJson(rawContent);
        if (parsedHtml) {
          contentDiv.innerHTML = parsedHtml;
        }
      }
    });
  }

  // Initialize function - attach listeners to buttons
  function initCollectionPageInfo() {
    const buttons = document.querySelectorAll('.collection-page-info__title');
    buttons.forEach(attachButtonListener);
    
    // Fix rich text descriptions that are showing as JSON
    fixRichTextDescriptions();
  }

  // Register custom element
  if (!customElements.get('collection-page-info')) {
    customElements.define(
      'collection-page-info',
      class CollectionPageInfo extends HTMLElement {
        connectedCallback() {
          const button = this.querySelector('.collection-page-info__title');
          if (button) {
            attachButtonListener(button);
          }
        }
      }
    );
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionPageInfo);
  } else {
    // DOM is already ready
    initCollectionPageInfo();
  }
  
  // Watch for dynamically added content
  if (window.MutationObserver) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            const buttons = node.querySelectorAll ? node.querySelectorAll('.collection-page-info__title') : [];
            buttons.forEach(attachButtonListener);
            
            // Also check if the node itself is a button
            if (node.classList && node.classList.contains('collection-page-info__title')) {
              attachButtonListener(node);
            }
            
            // Fix rich text descriptions in newly added content
            const descriptions = node.querySelectorAll ? node.querySelectorAll('.collection-page-info__description') : [];
            if (node.classList && node.classList.contains('collection-page-info__description')) {
              descriptions.push(node);
            }
            descriptions.forEach(function(description) {
              const contentDiv = description.querySelector('.collection-page-info__description-content');
              if (contentDiv) {
                const rawContent = contentDiv.textContent.trim();
                if (rawContent.startsWith('{') && rawContent.includes('"type":"root"')) {
                  const parsedHtml = parseRichTextJson(rawContent);
                  if (parsedHtml) {
                    contentDiv.innerHTML = parsedHtml;
                  }
                }
              }
            });
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Also initialize after delays to catch dynamically loaded content
  setTimeout(initCollectionPageInfo, 100);
  setTimeout(initCollectionPageInfo, 500);
})();
